import { render, staticRenderFns } from "./CostGlList.vue?vue&type=template&id=56169ed6&scoped=true"
import script from "./CostGlList.vue?vue&type=script&lang=js"
export * from "./CostGlList.vue?vue&type=script&lang=js"
import style0 from "./CostGlList.vue?vue&type=style&index=0&id=56169ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56169ed6",
  null
  
)

export default component.exports